
import { Lesson } from '@/models/Lesson';
import { LessonQueryService } from './LessonQueryService';
import { LessonMutationService } from './LessonMutationService';

export class LessonService {
  private queryService: LessonQueryService;
  private mutationService: LessonMutationService;

  constructor() {
    this.queryService = new LessonQueryService();
    this.mutationService = new LessonMutationService();
  }

  // Query methods
  async getActiveLessons(): Promise<Lesson[]> {
    return this.queryService.getActiveLessons();
  }

  async getUserLessons(userId: string): Promise<Lesson[]> {
    return this.queryService.getUserLessons(userId);
  }

  async getAllLessons(): Promise<Lesson[]> {
    return this.queryService.getAllLessons();
  }

  async getLesson(lessonId: string): Promise<Lesson | null> {
    return this.queryService.getLesson(lessonId);
  }

  // Mutation methods
  async addLesson(userId: string, lesson: Omit<Lesson, 'id'>): Promise<Lesson | null> {
    return this.mutationService.addLesson(userId, lesson);
  }

  async updateLesson(lessonId: string, updates: Partial<Lesson>): Promise<boolean> {
    return this.mutationService.updateLesson(lessonId, updates);
  }

  async deleteLesson(lessonId: string): Promise<boolean> {
    return this.mutationService.deleteLesson(lessonId);
  }

  async updateLessonsOrder(lessons: Lesson[]): Promise<boolean> {
    return this.mutationService.updateLessonsOrder(lessons);
  }
  
  async markLessonCompleted(lessonId: string, userId: string): Promise<boolean> {
    return this.mutationService.markLessonCompleted(lessonId, userId);
  }
}

export const lessonService = new LessonService();
